module.exports = __webpack_public_path__ + "img/base_activites_rando_journee.dd6a3efc.svg";